export const DATASEAT_NETWORK_ID = "m8dbw4sv7c.skadnetwork";
export const VERVE_NETWORK_ID = "tl55sbb4fm.skadnetwork";
